import moment from 'moment-timezone';

export default {
	install(Vue) {
		window.moment = moment;
		Vue.prototype.$moment = moment;
		Object.defineProperties(Vue.prototype, { moment: { get() { return moment; } } });
	},
};
